import axios from 'axios'

export const API_URL = process.env.NODE_ENV == "development"
  ? "https://local.officefinder.pl/rfp/api"
  : "https://www.officefinder.pl/rfp/api";

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': token
}

// Generate a unique token for storing your bookshelf data on the backend server.
let token = localStorage.token
if (!token)
  token = localStorage.token = Math.random().toString(36).substr(-8)

const initialState = {
  rfpData: {},
  questions: {},
  otherRFPs: []
}

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');

    if (serializedState === null) {
      const state = JSON.stringify(initialState)
      saveState(state)

      return initialState
    }
    return JSON.parse(serializedState);

  } catch (err) {
    return undefined;
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // ignore write errors
  }
}

export function getInitialData (hashId) {
  return Promise.all([
    getRFPData(hashId),
    getRFPQuestions(hashId),
    getOtherRFPs(hashId)
  ]).then(([rfpData, questions, otherRFPs]) => ({
    rfpData,
    questions,
    otherRFPs
  }))
}

export const getRFPData = (hashId) =>
  axios.get(`${API_URL}/getRFPData/${hashId}`)
    .then(res => res.data)

export const getRFPQuestions = (hashId) =>
  axios.get(`${API_URL}/getRFPQuestions/${hashId}`)
    .then(res => res.data)

export const getOtherRFPs = (hashId) =>
  axios.get(`${API_URL}/getOtherRFPs/${hashId}`)
    .then(res => res.data)

export const getRFPContacts = (rfpId) =>
  axios.get(`${API_URL}/getRFPContacts/${rfpId}`)
    .then(res => res.data)    

export const saveAnswer = (id, answer) =>
  axios.post(`${API_URL}/saveQuestionAnswer`, JSON.stringify({id, answer}))

export const saveFlexData = (rfpId, formData) =>
  axios.post(`${API_URL}/saveFlexData`, JSON.stringify({rfpId, formData}))
    .then(res => res.data)

export const saveFlexOptionData = (rfpId, optionIndex, formData) =>
  axios.post(`${API_URL}/saveFlexOptionData`, JSON.stringify({rfpId, optionIndex, formData}))
    .then(res => res.data)

export const saveNumberOfOptions = (rfpId, numberOfOptions) =>
  axios.post(`${API_URL}/saveNumberOfOptions`, JSON.stringify({rfpId, numberOfOptions}))
    .then(res => res.data)

export const uploadAttachments = (data) =>
  axios.post(`${API_URL}/uploadAttachments`, data)
    .then(res => res.data)

export const saveAttachmentData = (data) =>
  axios.post(`${API_URL}/saveAttachmentData`, data)
    .then(res => res.data)

export const deleteAttachment = (attachmentId) =>
  axios.post(`${API_URL}/deleteAttachment`, JSON.stringify({attachmentId}))
    .then(res => res.data)

export const saveCommercialTerms = (data) =>
  axios.post(`${API_URL}/saveCommercialTerms`, data)
    .then(res => res.data)

export const saveSpace = (data) =>
  axios.post(`${API_URL}/saveSpace`, data)
    .then(res => res.data)

export const saveParkings = (data) =>
  axios.post(`${API_URL}/saveParkings`, data)
    .then(res => res.data)

export const saveServiceCharge = (data) =>
  axios.post(`${API_URL}/saveServiceCharge`, data)
    .then(res => res.data)

export const submitProposal = (rfpId) =>
  axios.post(`${API_URL}/submitProposal`, JSON.stringify({rfpId}))
    //.then(res => res.data)


// WEBPACK FOOTER //
// ./src/utils/api.js